"use client";

import { useEffect } from "react";

import { onAppReady } from "./ready";

// Ends the launch screen (F179): once the app says it's ready (markAppReady)
// and the slogan's last line has appeared and been on screen HOLD_MS, it
// fades out and the session is marked, so it never shows again until the app
// is reopened. The animation starts at the first paint, not at the request,
// hence timing from the line itself. MAX_MS (from the request) ends it
// whatever happens (a slow or failed request).
const HOLD_MS = 800;
const MAX_MS = 5500;
const FADE_MS = 350;

export function LaunchController() {
  useEffect(() => {
    const root = document.documentElement;
    if (!root.classList.contains("launching")) return;
    let done = false;
    const timers: ReturnType<typeof setTimeout>[] = [];
    const finish = () => {
      if (done) return;
      done = true;
      root.classList.add("launch-out");
      timers.push(
        setTimeout(() => {
          root.classList.remove("launching", "launch-out");
          try {
            sessionStorage.setItem("shemshop:launched", "1");
          } catch {
            /* private mode: it just plays again next time */
          }
        }, FADE_MS),
      );
    };
    // The slogan has been read: its last line finished HOLD_MS ago.
    const shown = new Promise<void>((resolve) => {
      // `finished` also resolves if it ended before this code loaded.
      const animation = document.querySelector("#launch .launch-line:last-child")?.getAnimations()[0];
      if (!animation) return resolve();
      animation.finished.then(() => resolve(), () => resolve());
    }).then(() => new Promise<void>((resolve) => timers.push(setTimeout(resolve, HOLD_MS))));
    const ready = () => void shown.then(finish);
    // Outside /app nothing reports in: ready as soon as the page is here.
    const stop = window.location.pathname.startsWith("/app") ? onAppReady(ready) : (ready(), () => {});
    timers.push(setTimeout(finish, Math.max(0, MAX_MS - performance.now())));
    return () => {
      stop();
      timers.forEach(clearTimeout);
    };
  }, []);
  return null;
}
